<div class="signature-container">
  @if (readonly) {
    @if (value) {
      <img [src]="value" class="signature-image" alt="Signature" />
    } @else {
      <div class="signature-empty text-gray-500">
        {{ 'signature.noSignature' | transloco }}
      </div>
    }
  } @else {
    <canvas #canvas class="signature-canvas"></canvas>

    <div class="controls flex gap-2">
      <p-button
        (click)="clear()"
        [disabled]="!isReady || isEmpty"
        label="{{ 'modal.cancel' | transloco }}"
        icon="pi pi-times"
      />
      <p-button
        (click)="save()"
        [disabled]="!isReady || isEmpty || isSaved"
        label="{{ 'modal.save' | transloco }}"
        icon="pi pi-save"
      />
    </div>
  }
</div>